import axios from "axios";
//import { getToken, isTokenExpired, removeToken } from "../utils/token";

import { getToken, removeToken } from "../utils/token";
import { navigate } from "../utils/navigationHelper";
import { getStore } from "../utils/storeAccessor";
import { logoutUser } from "../features/auth/authSlice";
import { toast } from "react-toastify";

const BASE_URL = "https://pixadb.com/api/v1";
//const BASE_URL = "https://scraptrade.com.au/api/v1";

let isLoggingOut = false;

let isRefreshing = false;
let failedQueue = [];


// 🔹 ADD THIS HELPER FUNCTION RIGHT HERE
const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {  
      prom.resolve(token);
    }
  });

  failedQueue = [];
};


const apiClient = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
});

// New helper function
export const setAuthToken = (token) => {
  if (token) {
    localStorage.setItem("access_token", token);
    apiClient.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    console.log("Auth token set in axios + localStorage");

    //  Force all future requests to use the latest token immediately
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete apiClient.defaults.headers.common["Authorization"];
    delete axios.defaults.headers.common["Authorization"];
    localStorage.removeItem("access_token");
    localStorage.removeItem("token_expiry");
  }
};

// On startup, always load existing token
const existingToken = getToken();
if (existingToken) {
  apiClient.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${existingToken}`;
}

// Request Interceptor
apiClient.interceptors.request.use((config) => {
  const token = getToken();
  const isLoginRequest = config.url.endsWith("/login") || config.url.endsWith("/verify-login-otp");

  // Reset logging out flag if we are reaching a login/auth page explicitly
  if (isLoginRequest) {
    isLoggingOut = false;
    // Ensure no old token is sent during login
    if (config.headers.Authorization) {
      delete config.headers.Authorization;
    }
    return config;
  }

  // Proactive Expiry Check
  // if (token && isTokenExpired()) {
  //   // Only trigger if not already logging out
  //   if (!isLoggingOut) {
  //     isLoggingOut = true;
  //     console.log("Proactive Expiry Triggered. Expiry timestamp was:", localStorage.getItem("token_expiry"));
  //     const store = getStore();
  //     toast.error("Your session has expired. Please log in again.");
  //     removeToken();
  //     store.dispatch(logoutUser());
  //     navigate("/login");
  //   }

  //   // Silent Cancel using Axios CancelToken
  //   const source = axios.CancelToken.source();
  //   config.cancelToken = source.token;
  //   source.cancel("Token expired (Proactive)");
  //   return config;
  // }

  if (token) {
    // console.log("token attached to request", token);
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response Interceptor
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // If it's a manual cancel (like our expiry logic), just ignore it
    if (axios.isCancel(error)) {
      console.log("Request silently cancelled:", error.message);
      return new Promise(() => { }); // Return a pending promise to stay silent
    }

    const store = getStore();
    const state = store.getState();
    // const user = state.auth?.user;

    if (error.response) {
      const { status, data, config } = error.response;
      const requestUrl = config?.url || "";

      // 🔍 Better message extraction: check multiple nested locations
      const message =
        data?.message ||
        data?.error?.message ||
        data?.data?.message ||
        (typeof data === "string" ? data : null) ||
        "Something went wrong";

      console.log(`[API Error ${status}] Response:`, data);

      // Log validation errors specifically for the developer
      if (status === 422) {
        console.error("CRITICAL: Server validation failed (422). Error Data:", data);
        console.error("Payload sent was:", config.data);
      }

      // Fallback Errors
      switch (status) {
        case 400:
          toast.error(message);
          break;
        // case 401:
        //   if (!requestUrl.endsWith("/login") && !requestUrl.endsWith("/verify-login-otp") && !requestUrl.endsWith("/logout") && !isLoggingOut) {
        //     isLoggingOut = true;
        //     toast.error(message || "Your session has expired. Please log in again.");
        //     removeToken();
        //     store.dispatch(logoutUser());
        //     navigate("/login");
        //   }
        //   return Promise.reject({ status, message, data, isNetworkError: false });
        //   break;

        //  case 401: {

        //   // Ignore auth routes
        //   if (
        //     requestUrl.endsWith("/login") ||
        //     requestUrl.endsWith("/verify-login-otp") ||
        //     requestUrl.endsWith("/logout")
        //   ) {
        //     return Promise.reject({ status, message, data, isNetworkError: false });
        //   }

        //   // If refresh API itself fails → logout
        //   if (requestUrl.includes("/refresh-token")) {
        //     if (!isLoggingOut) {
        //       isLoggingOut = true;
        //       toast.error("Session expired. Please login again.");
        //       removeToken();
        //       store.dispatch(logoutUser());
        //       navigate("/login");
        //     }
        //     return Promise.reject({ status, message, data, isNetworkError: false });
        //   }

        //   const originalRequest = error.config;
        //   if (!originalRequest.headers) {
        //     originalRequest.headers = {};
        //   }

        //   const lastActivity = localStorage.getItem("last_activity");
        //   const isIdle =
        //     lastActivity && (Date.now() - lastActivity > 4 * 60 * 1000);  // 4 minutes idle threshold

        //   // 🔴 If user idle → show popup (NO refresh)
        //   if (isIdle) {
        //     window.dispatchEvent(new Event("sessionExpired"));
        //     return Promise.reject({ status, message, data, isNetworkError: false });
        //   }

        //   // 🟡 If already refreshing → queue request
        //   if (isRefreshing) {
        //     return new Promise((resolve, reject) => {
        //       failedQueue.push({ resolve, reject });
        //     })
        //       .then(token => {
        //         originalRequest.headers.Authorization = `Bearer ${token}`;
        //         return apiClient(originalRequest);
        //       })
        //       .catch(err => Promise.reject(err));
        //   }

        //   isRefreshing = true;

        //   return new Promise((resolve, reject) => {

        //     axios.post(`${BASE_URL}/refresh-token`, {}, {
        //       headers: {
        //         Authorization: `Bearer ${getToken()}`
        //       }
        //     })
        //     .then(res => {

        //       const newToken = res.data.access_token;

        //       setAuthToken(newToken);

        //       processQueue(null, newToken);

        //       originalRequest.headers.Authorization = `Bearer ${newToken}`;

        //       resolve(apiClient(originalRequest));
        //     })
        //     .catch(err => {

        //       processQueue(err, null);

        //       if (!isLoggingOut) {
        //         isLoggingOut = true;
        //         toast.error("Session expired. Please login again.");
        //         removeToken();
        //         store.dispatch(logoutUser());
        //         navigate("/login");
        //       }

        //       reject(err);
        //     })
        //     .finally(() => {
        //       isRefreshing = false;
        //     });

        //   });
        // }


        // case 401: {

        //   // 1️⃣ Ignore auth routes
        //   if (
        //     requestUrl.endsWith("/login") ||
        //     requestUrl.endsWith("/verify-login-otp") ||
        //     requestUrl.endsWith("/logout")
        //   ) {
        //     return Promise.reject({ status, message, data, isNetworkError: false });
        //   }

        //   // 2️⃣ If the request is /refresh-token, let the caller handle it
        //   if (requestUrl.includes("/refresh-token")) {
        //     // Do NOT force logout here
        //     return Promise.reject({ status, message, data, isNetworkError: false });
        //   }

        //   const originalRequest = error.config;
        //   if (!originalRequest.headers) {
        //     originalRequest.headers = {};
        //   }

        //   // 3️⃣ Check for user idle
        //   const lastActivity = localStorage.getItem("last_activity");
        //   const isIdle = lastActivity && (Date.now() - lastActivity > 4 * 60 * 1000); // 4 min idle

        //   if (isIdle) {
        //     window.dispatchEvent(new Event("sessionExpired"));
        //     return Promise.reject({ status, message, data, isNetworkError: false });
        //   }

        //   // 4️⃣ If already refreshing, queue the request
        //   if (isRefreshing) {
        //     return new Promise((resolve, reject) => {
        //       failedQueue.push({ resolve, reject });
        //     })
        //       .then(token => {
        //         originalRequest.headers.Authorization = `Bearer ${token}`;
        //         return apiClient(originalRequest);
        //       })
        //       .catch(err => Promise.reject(err));
        //   }

        //   // 5️⃣ Start token refresh
        //   isRefreshing = true;

        //   return new Promise((resolve, reject) => {

        //     axios.post(`${BASE_URL}/refresh-token`, {}, {
        //       headers: { Authorization: `Bearer ${getToken()}` }
        //     })
        //     .then(res => {

        //       const newToken = res.data.access_token;

        //       setAuthToken(newToken);           // Save new token
        //       processQueue(null, newToken);     // Retry queued requests
        //       originalRequest.headers.Authorization = `Bearer ${newToken}`;

        //       resolve(apiClient(originalRequest)); // Retry the failed request

        //     })
        //     .catch(err => {

        //       processQueue(err, null);

        //       // Only logout if refresh failed for a normal request
        //       if (!isLoggingOut) {
        //         isLoggingOut = true;
        //         toast.error("Session expired. Please login again.");
        //         removeToken();
        //         store.dispatch(logoutUser());
        //         navigate("/login");
        //       }

        //       reject(err);

        //     })
        //     .finally(() => {
        //       isRefreshing = false;
        //     });

        //   });
        // }


        case 401: {

          // 1️⃣ Ignore auth routes
          if (
            requestUrl.endsWith("/login") ||
            requestUrl.endsWith("/verify-login-otp") ||
            requestUrl.endsWith("/logout")
          ) {
            return Promise.reject({ status, message, data, isNetworkError: false });
          }

          // 2️⃣ If the request is /refresh-token, do NOT logout, let the caller handle it
          if (requestUrl.includes("/refresh-token")) {
            return Promise.reject(error); // <-- reject and do NOT logout
          }

          const originalRequest = error.config;
          if (!originalRequest.headers) originalRequest.headers = {};

          // 3️⃣ Check if user is idle (show modal)
          const lastActivity = localStorage.getItem("last_activity");
          const isIdle = lastActivity && (Date.now() - lastActivity > 5 * 60 * 1000);

          if (isIdle) {
            window.dispatchEvent(new Event("sessionExpired"));
            return Promise.reject(error); // do NOT logout here
          }

          // 4️⃣ If already refreshing, queue the request
          if (isRefreshing) {
            return new Promise((resolve, reject) => {
              failedQueue.push({ resolve, reject });
            })
              .then(token => {
                originalRequest.headers.Authorization = `Bearer ${token}`;
                return apiClient(originalRequest);
              })
              .catch(err => Promise.reject(err));
          }

          // 5️⃣ Start token refresh
          isRefreshing = true;

          return new Promise((resolve, reject) => {

            axios.post(`${BASE_URL}/refresh-token`, {}, {
              headers: { Authorization: `Bearer ${getToken()}` }
            })
              .then(res => {
                const newToken = res.data.access_token;

                setAuthToken(newToken);           // Save new token
                processQueue(null, newToken);     // Retry queued requests
                originalRequest.headers.Authorization = `Bearer ${newToken}`;

                resolve(apiClient(originalRequest)); // Retry the failed request

              })
              .catch(err => {
                processQueue(err, null);

                // ❌ Remove logout here! Just reject the promise
                reject(err);

              })
              .finally(() => {
                isRefreshing = false;
              });

          });
        }


        case 403:
          toast.error(message || "You do not have permission to perform this action.");
          break;
        case 404:
          toast.error(message || "The requested resource was not found.");
          break;
        case 500:
          toast.error(message || "Server error. Please try again later.");
          break;
        default:
          toast.error(message);
      }

      return Promise.reject({ status, message, data, isNetworkError: false });
    } else if (error.request) {
      return Promise.reject({
        status: null,
        message: "No response from server.",
        data: null,
        isNetworkError: true,
      });
    } else {
      toast.error(error.message);
      return Promise.reject({
        status: null,
        message: error.message,
        data: null,
        isNetworkError: false,
      });
    }
  }
);

export default apiClient;
